import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  Movement,
  MovementFilter,
  MovementPaged,
} from '../../models';
import { cleanEmptyProps } from '../../functions';

@Injectable({
  providedIn: 'root',
})
export class OpenedMovesService {
  private readonly API = `${environment.api_url}/movimentoAberto`;

  constructor(private http: HttpClient) {}

  getAll(body: MovementFilter): Observable<Movement[]> {
    return this.http.post<Movement[]>(`${this.API}/filtros`, body);
  }

  getAllFilterPaged(
    filters: MovementFilter,
    filterPaginator
  ): Observable<MovementPaged> {
    return this.http.post<MovementPaged>(`${this.API}/filtros`, filters, {
      params: cleanEmptyProps(filterPaginator),
    });
  }

  process(ids: number[]): Observable<void> {
    return this.http.post<void>(`${this.API}/integrar`, ids);
  }

  generateFile(body: MovementFilter): Observable<unknown> {
    return this.http.post<string>(
      `${environment.api_url}/relatorios/movimentosAbertos`,
      body,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          responseType: 'blob',
        }),
        responseType: 'blob' as 'json',
        observe: 'response',
      }
    );
  }
}
